













































import { faTimes } from '@fortawesome/free-solid-svg-icons'
import { debounce } from '~/utils/function'
import { mapState } from 'vuex'
import { USER_NS } from '~/store/modules/shared/user/state'
import { DEBOUNCE_DEFAULT } from '~/constants/debounce'
import { defineComponent } from '~/utils/nuxt3-migration'

export default defineComponent({
  data() {
    return {
      icons: {
        times: faTimes
      },
      query: '',
      results: null,
      trendingResults: null,
      searchOffset: 0,
      pageLimit: 30,
      maxLimit: 300,
      noMoreGifs: false,
      searching: false
    }
  },
  computed: {
    ...mapState(USER_NS, {
      userId: 'id'
    }),
    fetchUrl() {
      let link =
        'https://api.giphy.com/v1/gifs/trending?api_key=' +
        process.env.GIPHY_API_KEY +
        '&limit=' +
        this.pageLimit +
        '&rating=PG-13'

      if (this.userId) {
        link += '&random_id=' + this.userId
      }
      return link
    },
    displayedResults() {
      return this.trendingResults || this.results || null
    },
    searchUrl() {
      let link =
        'https://api.giphy.com/v1/gifs/search?api_key=' +
        process.env.GIPHY_API_KEY +
        '&q=' +
        this.query +
        '&limit=' +
        this.pageLimit +
        '&offset=' +
        this.searchOffset +
        '&rating=PG-13'

      if (this.userId) {
        link += '&random_id=' + this.userId
      }
      return link
    }
  },
  watch: {
    query(val) {
      if (val) {
        this.searchQueryChanged()
      } else {
        this.fetchTrending()
      }
    }
  },
  mounted() {
    this.fetchTrending()
    const cont = this.$refs.giphy
    cont.addEventListener('scroll', this.scroll)
    this.scroll()
  },
  methods: {
    focusInput() {
      this.$refs.searchinput.focus()
    },
    fetchTrending() {
      this.trendingResults = null
      this.$axios
        .get(this.fetchUrl)
        .then(response => {
          this.trendingResults = response.data.data
        })
        .catch(_error => {})
    },
    search() {
      if (this.query === '') {
        this.results = null
        this.fetchTrending()
        return
      }

      this.trendingResults = null

      this.searching = true

      this.$axios
        .get(this.searchUrl)
        .then(response => {
          if (this.searchOffset === 0 || this.results === null) {
            this.results = response.data.data
          } else {
            this.results.push(...response.data.data)

            if (
              response.data.data.length < this.pageLimit ||
              this.results.length >= this.maxLimit
            ) {
              this.noMoreGifs = true
            }
          }

          this.searching = false
        })
        .catch(_error => {
          this.searching = false
        })
    },
    gifClicked(result) {
      this.$emit('result', result)

      let analyticsLink = result.analytics.onsent.url + '&ts=' + Date.now()
      if (this.userId) {
        analyticsLink += '&random_id=' + this.userId
      }
      this.$axios.get(analyticsLink).catch(_error => {})
    },
    searchQueryChanged: debounce(function() {
      this.results = null
      this.noMoreGifs = false
      this.searchOffset = 0
      this.search()
    }, DEBOUNCE_DEFAULT),
    scroll() {
      if (!this.noMoreGifs) {
        const cont = this.$refs.giphy
        const offset = 60 // pixels
        const bottomOfWindow =
          cont.scrollTop > cont.scrollHeight - cont.offsetHeight - offset

        if (
          bottomOfWindow &&
          this.results &&
          this.searchOffset < Math.max(this.results.length, this.maxLimit) &&
          !this.noMoreGifs &&
          !this.searching
        ) {
          this.searchOffset = Math.min(this.results.length, this.maxLimit)
          this.search()
        }
      }
    },
    searchValue(val) {
      this.query = val
    }
  }
})
